import { PureComponent } from 'react'
import _ from 'lodash'
import { MenuSelect } from '@vzmi/shp_shared_compo'
import { withFormError } from '../../../../Common/Form'

class AttrClusterMenuSelect extends PureComponent {
  handleMenuSelect = (selectedAttrCluster, menuIndex, e) => {
    this.changeSettingClusterTo(selectedAttrCluster)

    const { value } = selectedAttrCluster
    this.changeProductClusterIdTo(value)
  }

  changeProductClusterIdTo = clusterId => {
    const {
      input: {
        onChange,
        onBlur
      }
    } = this.props

    if (_.isEmpty(clusterId)) {
      onChange(null)
      onBlur(null)
    } else {
      onChange(clusterId)
      onBlur(clusterId)
    }
  }

  changeSettingClusterTo = cluster => {
    const { triggerFieldChange } = this.props
    triggerFieldChange(
      'setting.struDataAttrCluster',
      cluster
    )
  }

  render () {
    const {
      input,
      options,
      ...restProps
    } = this.props

    const selectedClusterId = _.get(input, 'value')

    const matchedCluster = _.find(options, { value: selectedClusterId })
    const clusterLabel = [_.get(matchedCluster, 'label', '')]

    return (
      <MenuSelect
        {...restProps}
        options={options}
        value={clusterLabel}
        onSelect={this.handleMenuSelect}
      />
    )
  }
}
export const AttrClusterMenuSelectField = withFormError(AttrClusterMenuSelect)
